<template>
  <v-layout row wrap>
    <v-flex xs12 style="display: flex; flex-direction: column">
      <v-card v-if="modifiedNsdConfig" class="pa-2" style="flex: 1 1 auto; display: flex; flex-direction: column">
        <v-card-title
          class="pb-0"
          style="flex: 1 1 auto; flex-direction: column; align-items: start; position: relative"
        >
          <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.NextSurfacing.Configuration') }}</span>
          <v-switch
            hide-details
            class="pb-2 sm-switch"
            v-model="config.enableNsd"
            @change="saveConfig"
            :label="$t('Pilot.NextSurfacing.EnableNsd')"
            style="flex: 0 0 auto"
          />
          <div class="flex-container" style="align-self: stretch; flex: 1 0 auto">
            <div class="flex-container scrollable-container" :class="{ disable: !config.enableNsd }">
              <v-card ref="prioritybox1" class="mb-3 mx-0" :style="{ order: config.priority.indexOf('next') + 1 }">
                <div class="position">{{ config.priority.indexOf('next') + 1 }}</div>
                <v-card-title
                  style="background-color: #fafafa; padding-right: 40px; flex-direction: column; align-items: start"
                >
                  <v-btn @click.prevent="orderup('next')" small icon class="btnup"><v-icon>mdi-menu-up</v-icon></v-btn>
                  <span class="subheading">{{ $t('Pilot.NextSurfacing.NextSurfacing') }}</span>
                  <v-layout row wrap mt-2>
                    <v-flex xs-12>
                      <draggable v-model="config.nextSurfacings">
                        <v-chip
                          class="sortable"
                          close
                          small
                          v-for="(nextSurfacing, index) in config.nextSurfacings"
                          :key="index"
                          @input="removeFromNextSurfacingCmd(index)"
                        >
                          <v-avatar color="#ccc" class="darken-1">{{ index + 1 }}</v-avatar>
                          {{ nextSurfacing }}
                        </v-chip>
                      </draggable>
                    </v-flex>
                  </v-layout>
                  <v-btn @click.prevent="orderdown('next')" small icon class="btndown">
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-actions style="padding-right: 40px; background-color: #f5f5f5">
                  <glider-cmd-input
                    ref="nextSurfacingInput"
                    v-model="nextSurfacingCmd"
                    @validSaisie="addNextSurfacingCmd"
                    :label="$t('Pilot.NextSurfacing.Command')"
                    :gliderFabricant="mission.gliFabricant"
                  />
                  <v-btn @click.prevent="addNextSurfacingCmd" small icon><v-icon small>mdi-plus</v-icon></v-btn>
                </v-card-actions>
              </v-card>
              <v-card ref="prioritybox2" class="mb-3 mx-0" :style="{ order: config.priority.indexOf('all') + 1 }">
                <div class="position">{{ config.priority.indexOf('all') + 1 }}</div>
                <v-card-title style="background-color: #fafafa; padding-right: 40px">
                  <v-btn @click.prevent="orderup('all')" small icon class="btnup"><v-icon>mdi-menu-up</v-icon></v-btn>
                  <span class="subheading">{{ $t('Pilot.NextSurfacing.AllSurfacing') }}</span>
                  <v-spacer />
                  <v-switch
                    hide-details
                    class="pb-2 sm-switch"
                    v-model="config.enableAll"
                    :label="$t('Pilot.NextSurfacing.EnableAll')"
                    style="flex: 0 0 auto"
                  />
                  <v-container class="flex pa-0">
                    <v-layout row wrap mt-2>
                      <v-flex xs-12>
                        <draggable v-model="config.allSurfacings">
                          <v-chip
                            class="sortable"
                            close
                            small
                            v-for="(allSurfacing, index) in config.allSurfacings"
                            :key="index"
                            @input="removeFromAllSurfacingCmd(index)"
                          >
                            <v-avatar color="#ccc" class="darken-1">{{ index + 1 }}</v-avatar>
                            {{ allSurfacing }}
                          </v-chip>
                        </draggable>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-btn @click.prevent="orderdown('all')" small icon class="btndown">
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-actions style="padding-right: 40px; background-color: #f5f5f5">
                  <glider-cmd-input
                    ref="allSurfacingInput"
                    v-model="allSurfacingCmd"
                    @validSaisie="addAllSurfacingCmd"
                    :label="$t('Pilot.NextSurfacing.Command')"
                    :gliderFabricant="mission.gliFabricant"
                  />
                  <v-btn @click.prevent="addAllSurfacingCmd" small icon><v-icon small>mdi-plus</v-icon></v-btn>
                </v-card-actions>
              </v-card>
              <v-card ref="prioritybox3" class="mb-3 mx-0" :style="{ order: config.priority.indexOf('ncd') + 1 }">
                <div class="position">{{ config.priority.indexOf('ncd') + 1 }}</div>
                <v-card-title
                  style="background-color: #fafafa; padding-right: 40px; flex-direction: column; align-items: start"
                >
                  <v-btn @click.prevent="orderup('ncd')" small icon class="btnup"><v-icon>mdi-menu-up</v-icon></v-btn>
                  <span class="subheading">{{ $t('Pilot.NextSurfacing.NextConnect') }}</span>
                  <v-layout row wrap mt-2>
                    <v-flex xs-12>
                      <draggable v-model="config.nextConnects">
                        <v-chip
                          class="sortable"
                          close
                          small
                          v-for="(nextConnect, index) in config.nextConnects"
                          :key="index"
                          @input="removeFromNextConnectCmd(index)"
                        >
                          <v-avatar color="#ccc" class="darken-1">{{ index + 1 }}</v-avatar>
                          {{ nextConnect }}
                        </v-chip>
                      </draggable>
                    </v-flex>
                  </v-layout>
                  <v-btn @click.prevent="orderdown('ncd')" small icon class="btndown">
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-actions style="padding-right: 40px; background-color: #f5f5f5">
                  <glider-cmd-input
                    ref="nextConnectInput"
                    v-model="nextConnectCmd"
                    @validSaisie="addNextConnectCmd"
                    :label="$t('Pilot.NextSurfacing.Command')"
                    :gliderFabricant="mission.gliFabricant"
                  />
                  <v-btn @click.prevent="addNextConnectCmd" small icon><v-icon small>mdi-plus</v-icon></v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </v-card-title>
        <v-card-actions class="pr-3">
          <v-spacer />
          <!--<v-btn @click.prevent="resetConfig" small >{{$t('Pilot.FileTransfert.ResetConfig')}}<v-icon small right>mdi-backup-restore</v-icon></v-btn>-->
          <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>
            {{ $t('Pilot.NextSurfacing.RestoreConfig') }}
            <v-icon small right>mdi-replay</v-icon>
          </v-btn>
          <v-btn @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">
            {{ $t('Pilot.NextSurfacing.ValidateConfig') }}
            <v-icon small right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else class="pa-2" style="flex: 1 1 auto; display: flex; flex-direction: column">
        <v-card-title
          class="pb-0"
          style="flex: 1 1 auto; flex-direction: column; align-items: start; position: relative"
        >
          <span>{{ $t('Pilot.NextSurfacing.NoDataAvailable') }}</span>
        </v-card-title>
      </v-card>
    </v-flex>
    <!-- Dialog de chargement... -->
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ status }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import draggable from 'vuedraggable'
import deepEqual from 'deep-equal'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { MissionUi } from '@/models/ui/MissionUi'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { INextSurfacingDoConfig } from '@/models/iris/nextSurfacing/INextSurfacingDoConfig'
import GliderCmdInput from '@/components/shared/GliderCmdInput.vue'
import { AloMission } from '@/models/alo/AloMission'

@Component({
  name: 'MissionDetailNextSurfacingDo',
  components: { draggable, GliderCmdInput },
  props: {
    mission: {
      type: AloMission,
      required: true,
    },
  },
})
export default class MissionDetailNextSurfacingDo extends Vue {
  mission!: AloMission

  config = {
    enableNsd: true,
    enableAll: false,
    nextSurfacings: [] as Array<string>,
    allSurfacings: [] as Array<string>,
    nextConnects: [] as Array<string>,
    priority: ['next', 'all', 'ncd'],
  }

  nextSurfacingCmd = ''
  allSurfacingCmd = ''
  nextConnectCmd = ''

  get btnActif() {
    const config = {}
    this.loadConfig(config, this.originalNsdConfig)
    return this.config.enableNsd && !deepEqual(config, this.config) && !this.loading
  }

  get loading() {
    return this.$store.myGetters.nsdLoading
  }

  get status() {
    return this.$store.myGetters.gliderStatus
  }

  created() {
    if (this.mission.gliId != null)
      this.$store.myActions.GLIDER_IRIS_NSD_REQUEST(this.mission.gliId).then(() => {
        this.loadConfig(this.config, this.modifiedNsdConfig)
      })
  }

  mounted() {
    /*this.loadConfig(this.config,this.modifiedNsdConfig)*/
  }

  get originalNsdConfig() {
    return this.$store.myGetters.originalNsdConfigs[this.mission.gliId!]
  }

  get modifiedNsdConfig() {
    return this.$store.myGetters.modifiedNsdConfigs[this.mission.gliId!]
  }

  @Watch('mission')
  onMissionChanged(newValue: any) {
    if (newValue.gliId != null) this.$store.myActions.GLIDER_IRIS_NSD_REQUEST(newValue.gliId)
  }

  @Watch('modifiedNsdConfig')
  onModifiedNsdChanged(
    newConfig: IrisConfigContainer<INextSurfacingDoConfig>,
    oldConfig: IrisConfigContainer<INextSurfacingDoConfig>,
  ) {
    this.loadConfig(this.config, newConfig)
  }

  @Watch('config', { deep: true })
  onConfigChanged(newConfig: any) {
    this.validateConfig()
  }

  loadConfig(target: any, config: IrisConfigContainer<INextSurfacingDoConfig>) {
    if (config) {
      target.enableNsd = config.mod_settings.EnabledMOD['module-NextSurfacingDo']
      target.enableAll = config.mod_settings.NextSurfacingDo.exec_all_connect
      target.nextSurfacings = [...config.mod_settings.NextSurfacingDo_next.listAction]
      target.allSurfacings = [...config.mod_settings.NextSurfacingDo_all.listAction]
      target.nextConnects = [...(config.mod_settings.NextConnectDo?.listAction ?? [])]
      const rawPriority = [...config.mod_settings.NextSurfacingDo.priority_listAction]
      target.priority = rawPriority.includes('ncd') ? rawPriority : [...rawPriority, 'ncd']
    }
  }

  orderup(item: string) {
    const index = this.config.priority.indexOf(item)
    const newIndex = (this.config.priority.length + index - 1) % this.config.priority.length
    this.config.priority.splice(newIndex, 0, this.config.priority.splice(index, 1)[0])
  }

  orderdown(item: string) {
    const index = this.config.priority.indexOf(item)
    const newIndex = (this.config.priority.length + index + 1) % this.config.priority.length
    this.config.priority.splice(newIndex, 0, this.config.priority.splice(index, 1)[0])
  }

  validateConfig() {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_NSD({
      itemId: this.mission.gliId!,
      newProperties: {
        mod_settings: {
          EnabledMOD: {
            'module-NextSurfacingDo': this.config.enableNsd,
          },
          NextSurfacingDo: {
            exec_all_connect: this.config.enableAll,
            priority_listAction: [...this.config.priority],
          },
          NextSurfacingDo_all: {
            listAction: [...this.config.allSurfacings],
          },
          NextSurfacingDo_next: {
            listAction: [...this.config.nextSurfacings],
          },
          NextConnectDo: {
            listAction: [...this.config.nextConnects],
          },
        },
      },
    })
  }

  saveConfig() {
    this.validateConfig()
    this.$store.myActions.GLIDER_IRIS_NSD_SAVE_REQUEST(this.mission.gliId!)
  }

  restoreConfig() {
    this.$store.myActions.GLIDER_CANCEL_MODIFIED_NSD(this.mission.gliId!)
  }

  removeFromNextSurfacingCmd(index: number) {
    this.config.nextSurfacings.splice(index, 1)
  }

  async addNextSurfacingCmd() {
    if (this.nextSurfacingCmd.length > 0) {
      //@ts-ignore
      if (this.$refs.nextSurfacingInput && !(await this.$refs.nextSurfacingInput?.checkSaisie())) return
      this.config.nextSurfacings.push(this.cleanCommande(this.nextSurfacingCmd))
      this.$nextTick(() => (this.nextSurfacingCmd = ''))
    }
  }

  removeFromAllSurfacingCmd(index: number) {
    this.config.allSurfacings.splice(index, 1)
  }

  async addAllSurfacingCmd() {
    if (this.allSurfacingCmd.length > 0) {
      //@ts-ignore
      if (this.$refs.allSurfacingInput && !(await this.$refs.allSurfacingInput?.checkSaisie())) return
      this.config.allSurfacings.push(this.cleanCommande(this.allSurfacingCmd))
      this.$nextTick(() => (this.allSurfacingCmd = ''))
    }
  }

  removeFromNextConnectCmd(index: number) {
    this.config.nextConnects.splice(index, 1)
  }

  async addNextConnectCmd() {
    if (this.nextConnectCmd.length > 0) {
      //@ts-ignore
      if (this.$refs.nextConnectInput && !(await this.$refs.nextConnectInput?.checkSaisie())) return
      this.config.nextConnects.push(this.cleanCommande(this.nextConnectCmd))
      this.$nextTick(() => (this.nextConnectCmd = ''))
    }
  }

  cleanCommande(cmd: String) {
    let corrected = cmd.replace(/ /g, '')
    if (!corrected.endsWith(';')) corrected = `${corrected};`
    return corrected
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading,
.body-2 {
  font-weight: bold;
}

.btnup {
  position: absolute;
  top: -6px;
  right: -7px;
}
.btnup:hover {
  position: absolute;
}
.btndown {
  position: absolute;
  bottom: -6px;
  right: -7px;
}
.btndown:hover {
  position: absolute;
}

.flex-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.position {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 31px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.disable {
  overflow: hidden !important;
  position: relative;
}

.disable::before {
  position: absolute;
  content: '';
  left: 0px;
  right: 0px;
  top: 0px;
  height: 8000%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
